export default "__VITE_ASSET__Io6nHS$d__"